export default __webpack_public_path__ + "static/media/dbl-bookmarks-icon.c128479c.svg";